import React from 'react';
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { CssBaseline } from '@mui/material';

import { HashRouter } from 'react-router-dom';

// Context Providers
import { ThemeContextProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';

// Layout Components
import MainLayout from './components/layout/MainLayout';
import {
  ProtectedRoute,
  AdminRoute,
  OfficeRoute,
} from './components/auth/ProtectedRoute';

// Pages
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import UsersPage from './pages/users/UsersPage';
import CertificatesPage from './pages/certificates/CertificatesPage';
import CreateCertificatePage from './pages/certificates/CreateCertificatePage';
import CertsWithoutAttachmentsPage from './pages/certificates/CertsWithoutAttachmentsPage';
import SyncCertificatesPage from './pages/certificates/SyncPage';
import UnauthorizedPage from './pages/auth/UnauthorizedPage';
import NotFoundPage from './pages/common/NotFoundPage';

// Styles
import './styles/globals.css';

function App() {
  return (
    <ThemeContextProvider>
      <AuthProvider>
        <CssBaseline />
        <HashRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />

            {/* Protected Routes with Layout */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              {/* Dashboard */}
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />

              {/* Sync Page */}
              <Route index element={<Navigate to="/sync" replace />} />
              <Route path="sync" element={<SyncCertificatesPage />} />

              {/* Admin Only Routes */}
              <Route
                path="users"
                element={
                  <AdminRoute>
                    <UsersPage />
                  </AdminRoute>
                }
              />

              {/* Both Admin & Office Routes */}
              <Route path="certificates" element={<CertificatesPage />} />
              <Route path="certificates-without-attachments" element={<CertsWithoutAttachmentsPage />} />

              <Route
                path="certificates/create"
                element={
                  <OfficeRoute>
                    <CreateCertificatePage />
                  </OfficeRoute>
                }
              />
            </Route>

            {/* 404 Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </HashRouter>
      </AuthProvider>
    </ThemeContextProvider>
  );
}

export default App;
